import { useTranslation } from "react-i18next";
import LabelSelectRow from "../../../form/LabelSelectRow";
import { StyledFormSection } from "../../../styles";
import { PricingGeneralSetting } from "../../../constants";

enum Enabled {
  YES = "yes",
  NO = "no",
}

const OPTIONS = [Enabled.YES, Enabled.NO];

interface Props {
  disabled?: boolean;
}

const BillingSupplementSection = ({ disabled }: Props) => {
  const { t } = useTranslation("customers");

  return (
    <StyledFormSection
      title={t("contract.billingSupplements")}
      noBorder
      disablePaddingBottom
    >
      <LabelSelectRow
        label={t("contract.billingSupplement")}
        fieldName={PricingGeneralSetting.InvoiceFee}
        options={OPTIONS}
        getDisplayValue={(val) => t(`common:${val}`)}
        selectWidth={2}
        disabled={disabled}
      />
      <LabelSelectRow
        label={t("contract.repairBillingSupplement")}
        fieldName={PricingGeneralSetting.CreditInvoiceFee}
        options={OPTIONS}
        getDisplayValue={(val) => t(`common:${val}`)}
        selectWidth={2}
        disabled={disabled}
      />
    </StyledFormSection>
  );
};

export default BillingSupplementSection;
